import React from "react";

export default React.memo(function QuizStepIndicator({
  currentStep,
  totalSteps,
  onClickStepIndicator,
}) {
  let listItems = [];

  for (let i = 1; i <= totalSteps; i++) {
    listItems.push(
      <li
        key={i}
        className={currentStep === i ? "active" : ""}
        onClick={() => onClickStepIndicator(i)}
      ></li>
    );
  }

  return <ol className="quiz-step-indicators">{listItems}</ol>;
});
